import { PersonAdresse } from "../../interfaces/stamdata";

/**
 * Bygger en leveringsadresse op i linjer efter samme regler som AIKA (PostNord-format).
 * Returnerer en tom liste hvis der ikke er nogen brugbar adresse — det bruges til at
 * afgøre, om personen overhovedet har en registreret leveringsadresse i AIKA.
 */
export const formatAdresseLines = (
  adresse: PersonAdresse | null | undefined,
): string[] => {
  if (!adresse) return [];

  const landekode = adresse.landekode?.trim() || "DK";
  const postnummer = adresse.postnummer?.trim() ?? "";
  const bynavn = adresse.bynavn?.trim() ?? "";

  const lines: string[] = [];

  if (adresse.coNavn?.trim()) lines.push(`c/o ${adresse.coNavn.trim()}`);
  if (adresse.adresselinie1?.trim()) lines.push(adresse.adresselinie1.trim());
  if (adresse.adresselinie2?.trim()) lines.push(adresse.adresselinie2.trim());

  const postlinje = [postnummer, bynavn].filter(Boolean).join(" ");
  if (postlinje) {
    lines.push(landekode === "DK" ? postlinje : `${landekode} - ${postlinje}`);
  }

  if (adresse.adresselinie4?.trim()) lines.push(adresse.adresselinie4.trim());

  return lines;
};

/** Sand hvis der er nok af en adresse til at et kort kan sendes (mindst gade + by/postnr). */
export const harBrugbarAdresse = (
  adresse: PersonAdresse | null | undefined,
): boolean => {
  if (!adresse) return false;
  const harVej = Boolean(adresse.adresselinie1?.trim());
  const harByEllerPostnr = Boolean(
    adresse.bynavn?.trim() || adresse.postnummer?.trim(),
  );
  return harVej && harByEllerPostnr;
};
